module.exports = __webpack_public_path__ + "static/media/photo-2.32ab49a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/sussex-street-mixed-use/photo-2.jpg
// module id = 165
// module chunks = 0